import { SplashesV2Service } from '@/services/splashes-v2-service'
import { createAlertsBase } from './factories/alertsFactory'
import { defineStore } from 'pinia'
import type {
  SplashResponse,
  SplashesResponse,
  SplashesFilter,
  SplashesSortingKey,
} from '@/services/splashes-v2-service/types'

export const useSplashesStore = defineStore('splash-alerts', () => {
  const alertsBase = createAlertsBase<
    SplashResponse,
    SplashesResponse,
    SplashesFilter,
    SplashesSortingKey
  >({ sortBy: 'total_2h' }, SplashesV2Service.fetchSplashes)

  const sort = (sortByValue: string, sortOrderValue: number) => {
    alertsBase.sortBy.value = sortByValue as SplashesSortingKey
    alertsBase.sortOrder.value = sortOrderValue
  }

  alertsBase.sortBy.value = 'change'

  return {
    ...alertsBase,
    sort,
  }
})
